import { useT } from 'flyt/lib/language/language'
import type { StatesSkeletonProps } from './StatesSkeleton.types'

/**
 * states-skeleton — the portal's one standard loading placeholder.
 *
 * A vertical run of identical pulsing bars (pure CSS — no timers or effects)
 * inside a polite status region whose accessible name is the localized
 * loading label (`common` / `states.loading`). Stateless: output depends only
 * on the line count and the active locale.
 */
export function StatesSkeleton({ lines = 3 }: StatesSkeletonProps) {
  const t = useT('common')
  const count = Math.max(0, Math.trunc(lines))
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={t('states.loading')}
      className="flex flex-col gap-2"
    >
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className="h-2 w-full animate-pulse rounded-md bg-surface-muted" />
      ))}
    </div>
  )
}
